// this is required for invitations/edit as there were issues with js not bein run in the case of render for form error from controller.
window.processMultiStepForm = () => {
  preventDefaultButton();
  processStep();
  processFormSubmit();
  setupFieldValidation();

  function preventDefaultButton() {
    $('.next-step-btn, .previous-step-btn').on('click', function (e) {
      e.preventDefault();
    })
  }

  function isFieldValid(field) {
    var value = field.val();
    if (field.attr('type') === 'file') {
      return value.length > 0 || field.attr('data-files-present') === 'true';
    }
    return value != null && value.length > 0;
  }

  function showFieldError(field) {
    field.addClass('is-invalid').addClass('error-field');
    var $anchor = field.parent().hasClass('password-field') ? field.parent() : field;
    if ($anchor.siblings('.msf-error').length === 0) {
      $anchor.after('<div class="msf-error error-message text-danger small mt-1">This field is required</div>');
    }
  }

  function clearFieldError(field) {
    field.removeClass('is-invalid').removeClass('error-field');
    var $anchor = field.parent().hasClass('password-field') ? field.parent() : field;
    $anchor.siblings('.msf-error').remove();
  }

  function validateSection(fields) {
    var firstInvalid = null;
    $(fields).each(function () {
      clearFieldError($(this));
    });
    $(fields).each(function () {
      var field = $(this);
      if (!isFieldValid(field)) {
        showFieldError(field);
        if (!firstInvalid) firstInvalid = field;
      }
    });
    return firstInvalid;
  }

  function setupFieldValidation() {
    $(document).off('change.multi-step-form blur.multi-step-form', '.requiredField').on('change.multi-step-form blur.multi-step-form', '.requiredField', function () {
      var field = $(this);
      if (isFieldValid(field)) {
        clearFieldError(field);
      }
    });
  }

  function processStep() {
    $('.next-step-btn, .previous-step-btn').on('click', function (e) {
      let currentSection = $(`#${$(e.target).data('current')}`);
      if (currentSection.length !== 0) {
        const inputs = currentSection[0].querySelectorAll('input');
        let hasNativeError = false;

        inputs.forEach(input => {
          if (!input.checkValidity()) {
            input.reportValidity();
            hasNativeError = true;
          }
        });

        let allRequiredFields = currentSection.find('.requiredField');
        let firstInvalid = validateSection(allRequiredFields);

        if (firstInvalid) {
          firstInvalid[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus();
          e.stopPropagation();
          e.preventDefault();
        } else if (hasNativeError) {
          e.stopPropagation();
          e.preventDefault();
        } else {
          var targetId = $(this).data("target")
          $(targetId).click();
        }
      } else {
        var targetId = $(this).data("target");
        $(targetId).click();
      }
    });
  }

  function processFormSubmit() {
    $('.triggerValidation').on('click', function(e) {
      let currentSection = $(`#${$(e.target).data('current')}`);
      if (currentSection.length !== 0) {
        let allRequiredFields = currentSection.find('.requiredField');
        let firstInvalid = validateSection(allRequiredFields);

        if (firstInvalid) {
          firstInvalid[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus();
          e.stopPropagation();
          e.preventDefault();
        }
      }
    });
  }

}

// Shared step-1 validation + deferred-button gating used by both individual and company partials.
// Error display matches the msf-error pattern used everywhere else in the app
// (see showFieldError/clearFieldError above) — this used to toggle is-invalid
// against a static .invalid-feedback div instead, which looked inconsistent
// with every other required-field error on the site.
window.initOnboardingStep1 = function(formId) {
  var form = document.getElementById(formId);
  if (!form) return;

  function showStep1FieldError(field) {
    field.classList.add('is-invalid');
    var $field = $(field);
    if ($field.siblings('.msf-error').length === 0) {
      $field.after('<div class="msf-error error-message text-danger small mt-1">This field is required</div>');
    }
  }

  function clearStep1FieldError(field) {
    field.classList.remove('is-invalid');
    $(field).siblings('.msf-error').remove();
  }

  function validateFields(fields) {
    var invalid = false;
    fields.forEach(function(field) {
      var val = field.value ? field.value.trim() : '';
      if (val === '') {
        showStep1FieldError(field);
        invalid = true;
      } else {
        clearStep1FieldError(field);
      }
    });
    return invalid;
  }

  function allRequiredFilled() {
    return Array.from(form.querySelectorAll('.requiredField')).every(function(f) {
      return f.value && f.value.trim() !== '';
    });
  }

  var deferredBtn = form.querySelector('.deferred-link');

  function updateDeferredBtn() {
    if (!deferredBtn) return;
    deferredBtn.disabled = !allRequiredFilled();
  }

  updateDeferredBtn();

  form.querySelectorAll('.requiredField').forEach(function(field) {
    field.addEventListener('input', function() {
      clearStep1FieldError(this);
      updateDeferredBtn();
    });
    field.addEventListener('change', function() {
      clearStep1FieldError(this);
      updateDeferredBtn();
    });
  });

  var nextBtn = document.querySelector('.onboarding-next-btn');
  if (nextBtn) {
    nextBtn.addEventListener('click', function(e) {
      var invalid = validateFields(Array.from(form.querySelectorAll('.requiredField')));
      if (invalid) {
        e.preventDefault();
        e.stopPropagation();
        var first = form.querySelector('.requiredField.is-invalid');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }
};

document.addEventListener('turbolinks:load', function () {
  if ($('.projects.new, .projects.hud_project, .health_inspections.new, .health_inspections.edit,  .projects.create, .projects.edit, .projects.update, .organizations.new, .organizations.create, .organizations.edit, .organizations.update, .billings.new, .billings.create, .billings.edit, .billings.update, .teams.edit, .projects.create_hud_project, .projects.edit_hud_project, .projects.update_hud_project, #newSessionModal, .gl_codes.new, .gl_codes.create, .gl_codes.edit, .gl_codes.update').length === 0) {
    return false
  }

  // do not want to trigger this js if we are working on permit applications form
  // even though it is permit applications form, it is served under projects/edit so this js gets triggered
  if($('.permit_applications-form-section').length !== 0) {
    return false
  }

  // do not want to trigger this js if we are working on permit applications v2 form
  // even though it is permit applications v2 form, it is served under projects/edit so this js gets triggered
  if($('.v2_permit_applications-form-section').length !== 0) {
    return false
  }

  processMultiStepForm();
});
